import React from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../context/auth";
import Sidebar from "../sidebar/Sidebar";
import "./ConditionalLayout.css";


const ConditionalLayout = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return (
      <div className="nav-container">
        <div className="desktop-sidebar">
          <Sidebar />
        </div>
        <div className="main-home-content">
          <Outlet />
        </div>
      </div>
    );
  }

  return (
    <div className="conditional-unauthenticated-container">
      <Outlet />
    </div>
  );
};

export default ConditionalLayout;
